export const getMonitoringBaseUrl = ({ companyIdEncrypted, cryptoJS }) => {
    try {
        const proxyIds = JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS || "[]")
        const decryptedCompanyId = cryptoJS.AES.decrypt(companyIdEncrypted, process.env.VUE_APP_ENCRYPTION_PW).toString(cryptoJS.enc.Utf8)
        const useMonitoringApi = proxyIds.indexOf(decryptedCompanyId) === -1
        return useMonitoringApi ? process.env.VUE_APP_MONITORING_API_URL : process.env.VUE_APP_APIURL + "/monitoring-api"
    } catch (e) {
        return process.env.VUE_APP_MONITORING_API_URL
    }
}

export const getAddedPlatforms = ({ currentPlatforms = [], selectedPlatforms = [], caseInsensitive = true, project }) => {
    const normalize = (value) => {
        const str = String(value)
        return caseInsensitive ? str.toLowerCase() : str
    }
    let currentSet = new Set((currentPlatforms || []).map((p) => normalize(p)))
    console.log("[getAddedPlatforms] raw currentPlatforms:", currentPlatforms)
    console.log(
        "[getAddedPlatforms] normalized currentPlatforms:",
        (currentPlatforms || []).map((p) => normalize(p))
    )
    console.log("[getAddedPlatforms] raw selectedPlatforms:", selectedPlatforms)
    console.log(
        "[getAddedPlatforms] normalized selectedPlatforms:",
        (selectedPlatforms || []).map((p) => normalize(p))
    )
    console.log("[getAddedPlatforms] project.google value/type:", project?.google, typeof project?.google)
    console.log("[getAddedPlatforms] currentSet has exact 'google' BEFORE delete:", currentSet.has("google"))
    console.log("project", project.google)
    console.log("set", currentSet.has("google"))
    console.log("currentSet after removing google:", project.google && currentSet.has("google"))
    console.log("[getAddedPlatforms] currentSet entries AFTER delete:", Array.from(currentSet))
    let new_platforms = (selectedPlatforms || []).filter((p) => !currentSet.has(normalize(p)))
    if (project.google && new_platforms.includes("google")) new_platforms = new_platforms.filter((p) => p !== "google")
    return new_platforms
}

export const saveAiProjectSettings = async ({
    companyIdEncrypted,
    project,
    title,
    brandName,
    brandDomain,
    currentPlatforms,
    selectedPlatforms,
    axiosPost,
    cryptoJS,
    includePlatformsInUpdate = false,
    caseInsensitive = true
}) => {
    const addedPlatforms = getAddedPlatforms({ currentPlatforms, selectedPlatforms, caseInsensitive, project })
    console.log("added platforms saveAiProjectSettings", addedPlatforms)
    const payload = {
        company_id: companyIdEncrypted,
        project_id: project._id,
        update: {
            title,
            brand: { brand_name: brandName, brand_domain: brandDomain }
        }
    }
    if (includePlatformsInUpdate && addedPlatforms.length) {
        payload.update.platforms = addedPlatforms
    }

    const baseUrl = getMonitoringBaseUrl({ companyIdEncrypted, cryptoJS })
    const url = baseUrl + "/ai-suite/project/update/information"
    await axiosPost(url, payload)

    return { addedPlatforms, baseUrl, payload }
}

export const requestAddPlatformsUpdate = async ({ baseUrl, companyIdEncrypted, projectId, socketId, newPlatforms, axiosPost }) => {
    if (!Array.isArray(newPlatforms) || !newPlatforms.length) return null
    const url = baseUrl + "/project/add/platforms/later"
    const post_data = {
        company_id: companyIdEncrypted,
        project_id: projectId,
        socket_id: socketId,
        new_platforms: newPlatforms
    }
    try {
        return await axiosPost(url, post_data)
    } catch (error) {
        // 409 (laufender Import/Update/Abruf): Body wie eine normale Antwort durchreichen, damit der
        // Aufrufer response.data.error === "import_in_progress" auswerten kann
        const body = error && error.response && error.response.status === 409 && error.response.data
        if (body && typeof body === "object") return { data: body }
        throw error
    }
}

// addedPlatformsCount: Anzahl der NEU hinzugefügten Plattformen (google zählt als eine). Die API
// reserviert nur dafür, nicht für die bereits laufenden Plattformen - die Meldung muss dieselbe
// Zahl nennen. Ohne Angabe (alte Aufrufer) wird wie bisher über alle Plattformen gerechnet.
export const buildCreditsNotificationMessage = ({ project, responseData, addedPlatformsCount }) => {
    if (!project || !responseData?.data || responseData.data.error !== "not_enough_credits") return null
    const intervalMultiplier = project.interval == 28 || project.interval == 30 || project.interval == 31 ? 1 : project.interval == 7 ? 4 : 30
    const promptCount = project.prompt_count || 0
    const allPlatformsCount = project.google ? (project.platforms?.length || 0) + 1 : project.platforms?.length || 0
    const platformsCount = Number.isFinite(Number(addedPlatformsCount)) && Number(addedPlatformsCount) > 0 ? Number(addedPlatformsCount) : allPlatformsCount
    const requested = intervalMultiplier * promptCount * platformsCount
    const remaining = responseData.data.credits - responseData.data.count
    return "You do not have enough credits left. Requested prompt updates: " + requested + ". Remaining prompt updates: " + remaining
}
